import request from "./request"
// 获取单个样片
function getItemVideo(data) {
  data.Api = 'VideoProviderServicesSample.Get'
  return request({
    method: 'POST',
    data
  })
}
// 获取当前服务项目下的所有样片
function getVideoList(data) {
  data.Api = 'VideoProviderServicesSample.Search'
  return request({
    method: 'POST',
    data
  })
}
// 浏览埋点
function userBrowse(data) {
  data.Api = 'VideoProviderServicesSample.ViewsAdd'
  return request({
    method: 'POST',
    data
  })
}
export default {
  getItemVideo,
  getVideoList,
  userBrowse
}
